<template>
  <div class="promote">
      <div class="promote-banner"></div>
      <div class="promote-btn">
        <van-button class="right" type="primary" @click="to_form">立即开通</van-button>
      </div>
  </div>
</template>

<script>
import { Button } from 'vant';
import { toRefs, reactive, onMounted } from 'vue';
import { get } from '../../request/http';
import { useRoute, useRouter } from 'vue-router'

export default {
  components: {
    [Button.name]: Button,
  },

  setup() {
    const route = useRoute();
    const router = useRouter();
    const state = reactive({
      share_id: '', // 分享id
      invite_code: '',  // 邀请码
      type: '', // 类型
    });

    const get_share_info = (id) => {
      const params = { share_id: id }
      
      get('/api/share/info', params).then(res => {
        console.log('res', res)
        state.invite_code = res.data.data.invite_code
        state.type = res.data.data.type
      })
    }

    // 跳转
    const to_form = () => {
      router.push({ path: '/form', query: { parent_invite_code: state.invite_code, share_id: state.share_id }})
    }

    onMounted(() => {
      if (route.query.share_id) {
        state.share_id = route.query.share_id
        get_share_info(route.query.share_id);
      } 
    })

    return {
      to_form,
      get_share_info,
      ...toRefs(state)
    };
  }

};
</script>

<style lang="less">
.promote {
  min-height: 100vh;
  background: #160A86;

  &-banner {
    width: 100%;
    height: 110rem;
    background: url('https://supplinkcloud.s3.cn-north-1.jdcloud-oss.com/app_h5/collection_code.png') no-repeat;
    background-size: 100% 100%;
    background-position: center center;
    overflow: auto;
  }


  &-btn {
    text-align: center;
    button {
      position: fixed;
      bottom: 1.8rem;
      left: 50%;
      width: 28.6rem;
      height: 4.5rem;
      font-size: 1.6rem;
      color: #FFF;
      background: #035bf4;
      box-shadow: 0px 0px 4px 2px rgb(13 3 100 / 40%);
      border-radius: 2.3rem;
      transform: translate(-50%, 0);
    }
  }
}

</style>
